import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ArbitrationComponent } from './arbitration.component';
import { ArbitrationHomeComponent } from './components/home/arbitration-home.component';
import { ArbitrationCalendarComponent } from './components/calendar/arbitration-calendar.component';
import { ArbitrationDepartmentComponent } from './components/department/arbitration-department.component';
import { ArbitrationAttachedComponent } from './components/attached/arbitration-attached.component';
import { ArbitrationRefereesComponent } from './components/referees/arbitration-referees.component';
import { ArbitrationEventsComponent } from './components/events/events.component';
import { SharedAttachmentsDetailComponent } from '@theme/components';

const routes: Routes = [
    {
        path: '',
        component: ArbitrationComponent,
        children: [
            { path: 'home', component: ArbitrationHomeComponent },
            { path: 'department', component: ArbitrationDepartmentComponent },
            { path: 'calendar', component: ArbitrationCalendarComponent },
            { path: 'referees', component: ArbitrationRefereesComponent },
            { path: 'attached/:sessionType', component: ArbitrationAttachedComponent },
            { path: 'attached/:sessionType/detail/:docId', component: SharedAttachmentsDetailComponent },
            { path: 'attached_text/:sessionType', component: ArbitrationAttachedComponent },
            { path: 'events', component: ArbitrationEventsComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ArbitrationRoutingModule {}
